import { siteInfo, heroStats, hotTopics } from '@/mocks/chigua';
import { colorChip, iconMap } from './icons';

export default function Hero() {
  const top = hotTopics[0];
  return (
    <section className="relative overflow-hidden bg-background-100 pt-32 pb-16 md:pt-40 md:pb-20">
      {/* decorative texture */}
      <div className="pointer-events-none absolute inset-0 opacity-60">
        <div className="absolute -right-24 top-10 h-72 w-72 rounded-full bg-primary-100 blur-3xl"></div>
        <div className="absolute -left-20 bottom-0 h-64 w-64 rounded-full bg-accent-100 blur-3xl"></div>
        <i className="ri-focus-2-line absolute left-[8%] top-24 hidden text-5xl text-primary-200 lg:block"></i>
        <i className="ri-quill-pen-fill absolute right-[10%] bottom-24 hidden rotate-12 text-6xl text-secondary-200 lg:block"></i>
      </div>

      <div className="relative mx-auto grid max-w-7xl items-center gap-10 px-4 md:px-6 lg:grid-cols-[1.1fr_0.9fr]">
        {/* left */}
        <div className="text-center lg:text-left">
          <div className="inline-flex items-center gap-2 rounded-full border border-primary-200 bg-background-50 px-3 py-1 text-xs font-semibold text-primary-700">
            <span className="relative flex h-2 w-2">
              <span className="absolute inline-flex h-full w-full animate-ping rounded-full bg-primary-500 opacity-75"></span>
              <span className="relative inline-flex h-2 w-2 rounded-full bg-primary-500"></span>
            </span>
            今日热瓜追踪中 · 深挖频道
          </div>

          <h1 className="mt-6 font-heading text-3xl font-black leading-tight tracking-tight text-foreground-950 sm:text-4xl md:text-5xl lg:text-[3.4rem]">
            瓜田深处的
            <span className="relative mx-2 inline-block">
              <span className="relative z-10 text-primary-600">蛛丝马迹</span>
              <span className="absolute inset-x-0 bottom-1 z-0 h-3 bg-secondary-200"></span>
            </span>
            <br />
            一次给你扒清楚
          </h1>

          <p className="mx-auto mt-5 max-w-xl text-base leading-relaxed text-foreground-600 lg:mx-0 md:text-lg">
            内幕线索、扒皮细节、前后矛盾点，我们按时间码对齐、逐帧放大、逐句比对。
            不只搬运热闹，更讲清每条暗线是怎么被发现的。
          </p>

          <div className="mt-8 flex flex-col items-center justify-center gap-3 sm:flex-row lg:justify-start">
            <a
              href="#hot"
              className="inline-flex w-full cursor-pointer items-center justify-center gap-2 whitespace-nowrap rounded-md bg-primary-500 px-6 py-3 text-sm font-bold text-background-50 transition-colors hover:bg-primary-600 sm:w-auto"
            >
              <i className="ri-fire-line text-lg"></i>
              看今日热瓜
            </a>
            <a
              href="#guide"
              className="inline-flex w-full cursor-pointer items-center justify-center gap-2 whitespace-nowrap rounded-md border border-background-300 bg-background-50 px-6 py-3 text-sm font-semibold text-foreground-800 transition-colors hover:border-primary-300 hover:text-primary-700 sm:w-auto"
            >
              <i className="ri-git-branch-line text-lg"></i>
              学会自己找疑点
            </a>
          </div>

          {/* stats */}
          <div className="mt-10 grid grid-cols-2 gap-px overflow-hidden rounded-xl border border-background-200 bg-background-200 sm:grid-cols-4">
            {heroStats.map((s) => (
              <div key={s.label} className="bg-background-50 px-4 py-4 text-center">
                <p className="font-heading text-2xl font-black text-primary-600 md:text-3xl">{s.value}</p>
                <p className="mt-1 text-xs text-foreground-500">{s.label}</p>
              </div>
            ))}
          </div>
        </div>

        {/* right editorial card */}
        <div className="relative mx-auto w-full max-w-md">
          <div className="absolute -inset-3 -rotate-1 rounded-2xl bg-primary-500/10"></div>
          <div className="relative overflow-hidden rounded-2xl border border-background-200 bg-background-50 p-5 shadow-sm md:p-6">
            <div className="flex items-center justify-between">
              <span className="inline-flex items-center gap-1.5 rounded-full bg-primary-500 px-2.5 py-1 text-xs font-bold text-background-50">
                <i className="ri-fire-fill"></i> 号外 · 榜首热瓜
              </span>
              <span className="text-xs text-foreground-400">编辑室头条</span>
            </div>

            <div className="mt-5 flex items-start gap-1">
              <span className="font-heading text-6xl font-black leading-none text-primary-200 md:text-7xl">
                {String(top.rank).padStart(2, '0')}
              </span>
              <i className={`mt-3 text-2xl ${iconMap[top.trend]} text-primary-500`}></i>
            </div>

            <h2 className="mt-3 font-heading text-xl font-bold leading-snug text-foreground-950 md:text-2xl">
              {top.title}
            </h2>
            <p className="mt-3 text-sm leading-relaxed text-foreground-600">{top.summary}</p>

            <div className="mt-4 flex items-center gap-2">
              <span className={`inline-flex rounded-full px-2.5 py-0.5 text-xs font-semibold ${colorChip[top.color]}`}>
                {top.tag}
              </span>
              <span className="text-xs text-foreground-400">
                <i className="ri-eye-line mr-1"></i>
                {top.views} 围观
              </span>
            </div>

            <a
              href="#hot"
              className="mt-5 inline-flex w-full cursor-pointer items-center justify-center gap-1 whitespace-nowrap rounded-md border border-primary-200 bg-primary-50 px-4 py-2.5 text-sm font-semibold text-primary-700 transition-colors hover:bg-primary-100"
            >
              进入完整时间线
              <i className="ri-arrow-right-line"></i>
            </a>
          </div>
        </div>
      </div>

      <p className="sr-only">{siteInfo.intro}</p>
    </section>
  );
}